import artifact from '$houdini/artifacts/CreateReportSubscription'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateReportSubscriptionStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
